module.exports = __webpack_public_path__ + "img/question.e8f5a4a5.png";